import { useState, useEffect } from "react";
import { handleError } from "./utitl/Utils";
import Routes from "./Routes";
import ErrorPage from "./pages/ErrorPage";

const App = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleAsyncError = (event) => {
      setError(event.error);
      handleError(event.error, {
        componentStack: event.error?.stack || "No stack trace",
      });
    };

    window.addEventListener("error", handleAsyncError);
    window.addEventListener("unhandledrejection", (event) => {
      setError(event.reason);
      handleError(event.reason, {
        componentStack: event.reason?.stack || "No stack trace",
      });
    });

    return () => {
      window.removeEventListener("error", handleAsyncError);
      window.removeEventListener("unhandledrejection", handleAsyncError);
    };
  }, []);

  if (error) {
    return <ErrorPage />;
  }

  return (
    <>
      <Routes />
    </>
  );
};

export default App;
